// Legacy helper functions to replace some of prototype.js functionalities.
// This file contains legacy practices and should be removed in future updates.
// All functions here are temporary solutions until proper modern alternatives are implemented.

/**
 * Executes all script tags within a container by recreating them.
 * @param {HTMLElement} container - The DOM element containing script tags
 */
function evalScripts(container) {
	const scripts = container.querySelectorAll('script');

	scripts.forEach(script => {
		const newScript = document.createElement('script');
		if (script.src) {
			newScript.src = script.src;
		} else {
			newScript.textContent = script.textContent;
		}

		script.parentNode.replaceChild(newScript, script);
	});
}

/**
 * Replaces a DOM element with either another element or HTML string,
 * and runs any script tags inside the new content.
 * @param {HTMLElement} oldEl - The element to be replaced
 * @param {string | HTMLElement} newContent - The replacement HTML string or DOM element
 */
function replaceElement(oldEl, newContent) {
	let newEl;

	if (typeof newContent === 'string') {
		const temp = document.createElement('div');
		temp.innerHTML = newContent.trim();
		newEl = temp.firstElementChild;

		if (!newEl) {
			return;
		};

		oldEl.replaceWith(newEl);
		evalScripts(newEl);
	} else if (newContent instanceof HTMLElement) {
		oldEl.replaceWith(newContent);
		evalScripts(newContent);
	}
}
